import { useState } from "react";
import { Controller } from "react-hook-form";
import { BiShow, BiHide } from "react-icons/bi";

function InputText({
  name,
  labelTitle,
  labelStyle = "", // Ensure label style is optional
  inputStyle = "",
  type = "text",
  containerStyle = "",
  control,
  rules,
  readOnly = false,
  upperCaseOnly = false,
  defaultValue,
  updateType,
  updateFormValue,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  // If control is provided, use react-hook-form Controller
  if (control) {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <div className={`form-control w-full ${containerStyle}`}>
            {labelTitle && (
              <label className="label">
                <span className={"text-black text-sm " + labelStyle}>
                  {labelTitle}
                </span>
              </label>
            )}

            <div className="relative">
              <input
                {...field}
                type={showPassword ? "text" : type}
                readOnly={readOnly}
                className={`input bg-transparent text-black border-gray-300 focus:border-2 focus:border-gray-300 input-bordered w-full ${inputStyle}`}
                onChange={(e) => {
                  let newValue = e.target.value;
                  if (upperCaseOnly) newValue = newValue.toUpperCase();
                  field.onChange(newValue);
                }}
              />

              {type === "password" && (
                <span
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 cursor-pointer"
                >
                  {showPassword ? <BiHide className="h-6 w-6" /> : <BiShow className="h-6 w-6" />}
                </span>
              )}
            </div>
          </div>
        )}
      />
    );
  }

  // Fallback to regular input with updateFormValue callback (for non-react-hook-form usage)
  return (
    <div className={`form-control w-full ${containerStyle}`}>
      {labelTitle && (
        <label className="label">
          <span className={"text-black text-sm " + labelStyle}>
            {labelTitle}
          </span>
        </label>
      )}

      <div className="relative">
        <input
          type={showPassword ? "text" : type}
          value={defaultValue}
          readOnly={readOnly}
          className={`input bg-transparent text-black border-gray-300 focus:border-2 focus:border-gray-300 input-bordered w-full ${inputStyle}`}
          onChange={(e) => {
            let newValue = e.target.value;
            if (upperCaseOnly) newValue = newValue.toUpperCase();
            if (updateFormValue) {
              updateFormValue({ updateType, value: newValue });
            }
          }}
        />

        {type === "password" && (
          <span
            onClick={togglePasswordVisibility}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 cursor-pointer"
          >
            {showPassword ? <BiHide className="h-6 w-6" /> : <BiShow className="h-6 w-6" />}
          </span>
        )}
      </div>
    </div>
  );
}

export default InputText;
